import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1517bc51"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "field"
}
const _hoisted_2 = {
  key: 1,
  class: "field"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createTextVNode(" Warning: this export will use the "),
  /*#__PURE__*/_createElementVNode("b", null, "saved"),
  /*#__PURE__*/_createTextVNode(" package, not the currently loaded one. Local edits will not be reflected. ")
], -1))
const _hoisted_4 = {
  key: 2,
  class: "field"
}
const _hoisted_5 = { class: "field has-addons" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Target", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "pdf", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "image", -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "control"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "File format", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "png", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "jpeg", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "field" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Maximum Quality", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "none", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "010", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "030", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "050", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "080", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "100", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "200", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "300", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "400", -1))
const _hoisted_28 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "field" }
const _hoisted_30 = {
  key: 0,
  class: "control"
}
const _hoisted_31 = { class: "checkbox" }
const _hoisted_32 = { class: "field" }
const _hoisted_33 = { class: "control" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "cewe-left", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "cewe-right", -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { class: "field" }
const _hoisted_38 = { class: "control" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Websocket URL", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "wss://ws.processor.api.bubblydoo.net/dev", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "wss://ws.processor.api.bubblydoo.net/prod", -1))
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "field" }
const _hoisted_44 = { class: "control" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Transfo Store URL", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "https://transfo-store-proxy-dev-backend.bubblydoo.net/dev", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "https://transfo-store-proxy-prod-backend.bubblydoo.net/prod", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "https://transfo-store.backend.bubbly-doo.com/dev", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "https://transfo-store.backend.bubbly-doo.com/prod", -1))
const _hoisted_50 = [
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "field" }
const _hoisted_52 = { class: "control" }
const _hoisted_53 = {
  class: "select is-small",
  disabled: ""
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Projects Store URL", -1))
const _hoisted_55 = { selected: "" }
const _hoisted_56 = { class: "field" }
const _hoisted_57 = { class: "control" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "field messages" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = ["href"]
const _hoisted_63 = { key: 2 }
const _hoisted_64 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelAttribute = _resolveComponent("PanelAttribute")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Export" }, {
    default: _withCtx(() => [
      (_ctx.pkg)
        ? (_openBlock(), _createBlock(_component_PanelAttribute, {
            key: 0,
            title: "Export"
          }, {
            default: _withCtx(() => [
              (_ctx.previewArgument)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createTextVNode(" Will use preview argument "),
                    _createElementVNode("code", null, _toDisplayString(_ctx.previewArgument.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, "No preview argument selected")),
              _hoisted_3,
              (!_ctx.viewKey)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No view selected"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("select", {
                    class: "select is-small",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.exportStuff.target) = $event))
                  }, _hoisted_10, 512), [
                    [_vModelSelect, _ctx.exportStuff.target]
                  ])
                ]),
                (_ctx.exportStuff.target === 'image')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("select", {
                        class: "select is-small",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.exportStuff.fileFormat) = $event))
                      }, _hoisted_15, 512), [
                        [_vModelSelect, _ctx.exportStuff.fileFormat]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    class: "select is-small",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.exportStuff.maximumQuality) = $event))
                  }, _hoisted_28, 512), [
                    [_vModelSelect, _ctx.exportStuff.maximumQuality]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.exportStuff.target === 'image' && _ctx.exportStuff.fileFormat === 'png')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.exportStuff.transparentBackground) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.exportStuff.transparentBackground]
                        ]),
                        _createTextVNode(" Transparent background ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.croppings) = $event)),
                    multiple: ""
                  }, _hoisted_36, 512), [
                    [_vModelSelect, _ctx.croppings]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("select", {
                    class: "select is-small",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.exportStuff.processorWebsocketUrl) = $event))
                  }, _hoisted_42, 512), [
                    [_vModelSelect, _ctx.exportStuff.processorWebsocketUrl]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _withDirectives(_createElementVNode("select", {
                    class: "select is-small",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.exportStuff.transfoStoreUrl) = $event))
                  }, _hoisted_50, 512), [
                    [_vModelSelect, _ctx.exportStuff.transfoStoreUrl]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("select", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.STORE_BASE_URL), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("button", {
                    class: "button is-small",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.runExport())),
                    disabled: !_ctx.exportStuff.maximumQuality || !_ctx.exportStuff.target || !_ctx.viewKey
                  }, " Export ", 8, _hoisted_58)
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "message",
                    key: i
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(message.message), 1)
                    ]),
                    (message.pointer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, " Spread: " + _toDisplayString(message.pointer[1]) + " - Cropping: " + _toDisplayString(message.pointer[2]), 1))
                      : _createCommentVNode("", true),
                    (message.url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("a", {
                            href: message.url,
                            target: "_blank"
                          }, "Asset", 8, _hoisted_62)
                        ]))
                      : _createCommentVNode("", true),
                    (message.results)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.results, (result, i) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: i,
                              href: result.url ? result.url : result.result.url,
                              target: "_blank"
                            }, "Asset " + _toDisplayString(result.pointer ? result.pointer : i), 9, _hoisted_64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}